@let form = this.form();
<div class="container-xl pt-2 small-print-padding-horizontal">
    <div class="row">
        <div class="col-12 col-lg order-1 order-lg-0">
            <h2>
                <b>
                    Urenspecificatie periode {{form?.controls.selectedYear.value ?? 'Alle jaren'}}
                    @if (form?.controls.selectedPeriod.value) {
                        - {{form?.controls.selectedPeriod.value}}
                    }
                </b>
            </h2>

            @if (form?.controls.selectedCompany.value && selectedCompany()) {
                <div class="company-data-fs">
                    <div>{{selectedCompany().name}}</div>
                    <div>{{selectedCompany().street}} {{selectedCompany().number}}</div>
                    <div>{{selectedCompany().postal_code}} {{selectedCompany().city}}</div>
                </div>
            }

            @if (form?.controls.selectedUser.value && selectedUser()) {
                <div class="company-data-fs">
                    <div>{{selectedUser().name}}</div>
                </div>
            }

            <div class="mt-3 page-break-avoid">
                <h2>
                    <b>Besteding per Project</b>
                </h2>
                <div class="d-flex justify-content-end gap-2">
                    <h4 class="m-0">
                        <strong>Totaal</strong>
                    </h4>
                    <h4 class="m-0">
                        <strong>Periode</strong>
                    </h4>
                </div>
                @for (parentProject of (projects() | filter : parentProjectIds() : 'id'); track parentProject.id) {
                    @let childProjectsWithTime = getChildProjectsWithTime(parentProject);
                    @if (childProjectsWithTime?.length > 0) {
                        <div class="my-4 page-break-avoid">
                            @for (project of childProjectsWithTime; track project.id) {
                                @if ((periodTotals() | byId : project.id : 'work_project_id')?.time > 0) {
                                    <div class="row project-hover">
                                        <span class="col">
                                            @if (parentProject.name) {
                                                {{parentProject.name}} &raquo;
                                            }
                                            {{project.name}}
                                        </span>
                                        <span class="col-auto text-end">{{(periodTotals() | byId : project.id : 'work_project_id')?.totaltime | minutes}}
                                            @if (+project.budget > 0) {
                                                / {{project.budget * 60 | minutes}}
                                            }
                                        </span>
                                        <span class="col-auto text-end period-width">{{(periodTotals() | byId : project.id : 'work_project_id')?.time | minutes}}</span>
                                    </div>
                                    <hr>
                                }
                            }
                            <div class="row">
                                <strong class="col">
                                    Subtotaal
                                    @if (!form?.controls.selectedCompany.value) {
                                        {{companies() | companyName:parentProject.company_id}}
                                        @if (parentProject.name) {
                                            &raquo;
                                        }
                                    }
                                    {{parentProject.name}}:
                                </strong>
                                <span class="col-auto text-end">{{getChildProjectTotals(parentProject) | sum : 'totaltime' | minutes}} /
                                    @let parentTotalBudget = childProjectsWithTime | sum : 'budget';
                                    @if (parentTotalBudget > 0) {
                                        {{parentTotalBudget * 60 | minutes}}
                                    } @else {
                                        -
                                    }
                                </span>
                                <strong class="col-auto text-end period-width">{{getChildProjectTotals(parentProject) | sum : 'time' | minutes}}</strong>
                            </div>
                        </div>
                    }
                }
                <div class="d-flex justify-content-between">
                    <h4>
                        <strong>Totaal
                            @if (form?.controls.selectedYear.value) {
                                Periode {{form?.controls.selectedPeriod.value}} {{form?.controls.selectedYear.value}}
                            } @else {
                                Alle jaren
                            }:
                        </strong>
                    </h4>
                    <h4>
                        <strong>{{periodTotals() | sum : 'time' | minutes}}</strong>
                    </h4>
                </div>
            </div>

            @if (form?.controls.selectedYear.value !== null) {
                <div class="mt-3 page-break-avoid">
                    <h2>
                        <b>Besteding per dag</b>
                    </h2>
                    @for (day of registrationsByDay(); track day.date) {
                        <registrations-by-day
                            [companies]="companies()"
                            [contextMenuFn]="changeRegistrationProjectFn"
                            [registrationDay]="day"
                            [showCompany]="!!form?.controls.selectedCompany.value"
                            [showUser]="!!form?.controls.selectedUser.value">
                        </registrations-by-day>
                    }
                </div>

                @if (hasGlobalReports && !form?.controls.selectedUser.value) {
                    <div class="mt-4 page-break-avoid">
                        <h2>
                            <strong>Besteding per medewerker</strong>
                        </h2>
                        @for (user of totalsByUser(); track user.name) {
                            <div class="d-flex justify-content-between">
                                <span>{{user.name}}</span>
                                <span>{{user.totalMinutes | minutes}}</span>
                            </div>
                            <hr>
                        }
                    </div>
                }
            }
        </div>
        <div class="col-12 col-lg-4 d-print-none">
            <div class="filter-bar">
                <div class="row mb-3">
                    <div class="col">
                        <h2>
                            <b>Filter</b>
                        </h2>
                    </div>
                    <div class="col-auto">
                        @if (hasGlobalReports) {
                            <div class="col-auto align-self-center">
                                <button (click)="downloadReport()" [disabled]="generatingReport()" class="btn btn-primary">
                                    PDF
                                    @if (generatingReport()) {
                                        <i class="fas fa-circle-notch fa-spin"></i>
                                    }
                                </button>
                            </div>
                        }
                    </div>
                </div>
                @if (form) {
                    <div [formGroup]="form" class="row text-center mb-4">
                        <div class="col-6">
                            <b>Jaar</b>
                            <div class="d-flex gap-2">
                                <div class="d-flex align-self-center">
                                    <button
                                        (click)="changeSelectedYear('decrement')"
                                        [class.disabled]="form?.controls.selectedYear.value === 2015 || form?.controls.selectedYear.value === null"
                                        class="btn btn-secondary">
                                        <i class="material-icons">remove</i>
                                    </button>
                                </div>
                                <div class="flex-fill">
                                    <ng-select
                                        [clearable]="true"
                                        [items]="years()"
                                        [searchable]="true"
                                        bindLabel="name"
                                        bindValue="value"
                                        formControlName="selectedYear">
                                    </ng-select>
                                </div>
                                <div class="d-flex align-self-center">
                                    <button
                                        (click)="changeSelectedYear('increment')"
                                        [class.disabled]="form?.controls.selectedYear.value === currentYear"
                                        class="btn btn-secondary">
                                        <i class="material-icons">add</i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <b>Periode</b>
                            <div class="d-flex gap-2">
                                <div class="d-flex align-self-center">
                                    <button
                                        (click)="changeSelectedPeriod('decrement')"
                                        [class.disabled]="form?.controls.selectedPeriod.value === 1 || form?.controls.selectedPeriod.value === null"
                                        class="btn btn-secondary">
                                        <i class="material-icons">remove</i>
                                    </button>
                                </div>
                                <div class="flex-fill">
                                    <ng-select
                                        [items]="periods()"
                                        [searchable]="true"
                                        bindLabel="name"
                                        bindValue="value"
                                        formControlName="selectedPeriod">
                                    </ng-select>
                                </div>
                                <div class="d-flex align-self-center">
                                    <button (click)="changeSelectedPeriod('increment')" [class.disabled]="form?.controls.selectedPeriod.value === 13" class="btn btn-secondary">
                                        <i class="material-icons">add</i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div class="mb-4">
                    <div class="d-flex justify-content-between">
                        <b>Medewerker</b>
                        <span (click)="form?.controls.selectedUser.setValue(null)" class="curpoint">Clear</span>
                    </div>
                    <mat-selection-list [multiple]="false">
                        @for (user of users(); track user.id) {
                            @if ((filterUsersYeartotals() | byId : user.id : 'user_id')?.time > 0) {
                                <mat-list-option
                                    (click)="selectUser($event, user.id)"
                                    [selected]="form?.controls.selectedUser.value === user.id"
                                    [togglePosition]="'before'"
                                    [value]="user.id">
                                    <span>{{user.name}}</span>
                                    <span>{{(filterUsersTotals() | byId : user.id : 'user_id')?.time | minutes}}</span>
                                </mat-list-option>
                            }
                        }
                    </mat-selection-list>
                </div>
                <div>
                    <div class="d-flex justify-content-between">
                        <b>Bedrijf</b>
                        <span (click)="form?.controls.selectedCompany.setValue(null)" class="curpoint">Clear</span>
                    </div>
                    <mat-selection-list [multiple]="false">
                        @for (company of companies(); track company.id) {
                            @if ((filterCompaniesYeartotals() | byId : company.id : 'company_id')?.time > 0) {
                                <mat-list-option
                                    (click)="selectCompany($event, company.id)"
                                    [selected]="form?.controls.selectedCompany.value === company.id"
                                    [togglePosition]="'before'"
                                    [value]="company.id">
                                    <span>{{company.name}}</span>
                                    <span>{{(filterCompaniesTotals() | byId : company.id : 'company_id')?.time | minutes}}</span>
                                </mat-list-option>
                            }
                        }
                    </mat-selection-list>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container overflow-y-auto">
    @if (!form?.controls.selectedCompany.value && form?.controls.selectedUser.value) {
        <div class="mt-4 page-break-avoid">
            <h4><strong>Totalen per week</strong></h4>
            <table class="table table-striped text-end text-nowrap">
                <thead>
                    <tr>
                        <th>Week</th>
                        <th>Maandag</th>
                        <th>Dinsdag</th>
                        <th>Woensdag</th>
                        <th>Donderdag</th>
                        <th>Vrijdag</th>
                        <th>Zaterdag</th>
                        <th>Zondag</th>
                        <th>Totaal</th>
                        <th>Contract</th>
                        <th>Balans</th>
                    </tr>
                </thead>
                <tbody>
                    @for (week of registrationsByWeek(); track week.week + '-' + week.year) {
                        <tr>
                            <td>{{week.year}}-{{week.week}}</td>
                            @for (dayNum of [1, 2, 3, 4, 5, 6, 0]; track dayNum) {
                                <td [matTooltip]="(week.days | dayOfWeek:dayNum)?.date | date:'dd-MM-yyyy'">{{(week.days | dayOfWeek:dayNum)?.totaltime_minutes | minutes}}</td>
                            }
                            <td>{{week.totaltime_decimal * 60 | minutes}}</td>
                            <td>{{week.assignment ?? '0:00'}}</td>
                            <td [class.text-danger]="((week.totaltime_decimal - (week.assignment_decimal ?? 0)) * 60) < 0">{{(((week.totaltime_decimal - (week.assignment_decimal ?? 0)) * 60) | minutes) || '0:00'}}</td>
                        </tr>
                    }
                    <tr class="fw-bold">
                        <td class="text-end" colspan="10">Totaal</td>
                        <td [class.text-danger]="(registrationsByWeek() | sumWeekMinutes:'balance') < 0">
                            {{(registrationsByWeek() | sumWeekMinutes:'balance' | minutes)}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    }
</div>
